import {
  ChangeDetectionStrategy,
  Component,
  input,
  OnInit,
  output,
  signal
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { getPreferredLanguage, initLanguage } from '@shared/utils';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';

interface LanguageDropdown {
  name: string;
  code: string;
}

@Component({
  selector: 'moxi-language-selector',
  imports: [
    FormsModule,

    TranslatePipe,

    // Ant Design
    NzDropDownModule,
    NzButtonModule
  ],
  templateUrl: './language-selector.component.html',
  styleUrl: './language-selector.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LanguageSelectorComponent implements OnInit {
  readonly assetsFolder = '/assets/images/';

  iconSize = input(32);

  languageUpdate = output<string>();

  languageFlag = signal(undefined);

  selectedLanguage?: string;
  languages: LanguageDropdown[] = [
    {
      name: 'shared.language.en',
      code: 'en'
    },
    {
      name: 'shared.language.de',
      code: 'de'
    }
  ];

  ngOnInit(): void {
    const language = getPreferredLanguage();

    this.languageFlag.set(`${this.assetsFolder}${language}.svg`);
    this.selectedLanguage = language;
  }

  onChangeLanguage(language: string): void {
    initLanguage(language);

    this.languageFlag.set(`${this.assetsFolder}${language}.svg`);
    this.selectedLanguage = language;
    this.languageUpdate.emit(language);
  }
}
